import React, {
	Component
} from 'react';
import { phaserMain } from '../game/phaserMain';
import {store} from '../stores/mainStore';
import {max} from 'lodash';


export class PhaserGame extends Component {

	constructor(props){
		super(props)
		this.index = store.phaserInstanceIndex;
		// console.log('construct index', store.phaserInstanceIndex);
	}

	startPhaser = (ref) => {
		if(ref !== null){
			// console.log('index', ref, this.index, store.phaserInstanceIndex);
			const height = max([320,window.innerHeight]);
			const width = max([320, window.innerWidth]);
			// console.log("WINDOW: "+window.innerWidth+", "+window.innerHeight);
			store.aspectRatio = width / height;
			phaserMain(width, height);
		}
	};

	//this only prevents updates based on props, of which we currently have none.
	shouldComponentUpdate(){
		return false;
	}

	render() {
		return (
			<div id="game-target" ref={this.startPhaser}></div>
		);
	}
}